export class ContactUsModel {
    firstName: string;
    lastName: string;
    email: string;
    address: string;
    message: string;
}
